import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { IEDate, uGetDateFormat } from '@appbase/util';

@Component({

})
export default class DatetimeField  extends Vue {
    @Prop({ type: String }) displayName!: string;
    @Prop({ type: String }) fieldValue!: string;

    mDisplayValue: string = "";

    created() {
        var dateValue = IEDate(this.fieldValue);
        this.mDisplayValue = uGetDateFormat('yyyy년MM월dd일 H시i분', dateValue);
    }
}